
<ng-container *ngIf="presetMode">
  <spinner *ngIf="permissionPresets === null"></spinner>
  <ng-container *ngIf="permissionPresets !== null">
    <div class="d-flex align-items-center mb-2">
      <label class="mr-auto mb-0" translate>Permission presets</label>
    </div>
    <entity-list className="list-group list-group-light" [showFilter]="false" [entities]="permissionPresets" [filterKeys]="['name']">
      <ng-template entityListItem let-p="entity"><a class="list-group-item list-group-item-action" *ngIf="isPresetAllowed(p)" (click)="togglePreset(p, !isPresetEnabled(p))">
          <checkbox [checked]="isPresetEnabled(p)" [text]="p.name"></checkbox></a></ng-template>
    </entity-list>
  </ng-container>
</ng-container>
<div class="d-flex" *ngIf="!presetMode">
  <div class="w-50 mr-5">
    <div class="form-group" data-test-qa="optionsGroup">
      <div class="d-flex align-items-center mb-2">
        <label class="mr-auto mb-0" translate>Permissions</label><a class="ml-2" translate (click)="$event.preventDefault(); setAllPermissions(schema.permissionGroups[0])" data-test-qa="setAll-Permissions">All</a><a class="ml-2" translate (click)="$event.preventDefault(); setNoPermissions(schema.permissionGroups[0])" data-test-qa="setNone-Permissions">None</a>
      </div>
      <div *ngFor="let p of schema.permissionGroups[0].items">
        <ng-container *ngIf="isPermissionVisible(p.id)">
          <checkbox (click)="permissionModel.togglePermission(p)" [checked]="permission[p.id]" [disabled]="!isPermissionAllowed(p.id)" [text]="p.name|translate" [attr.data-test-qa]="p.id"></checkbox>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="w-50">
    <div class="form-group" data-test-qa="showGroup">
      <div class="d-flex align-items-center mb-2">
        <label class="mr-auto mb-0" translate>UI</label><a class="ml-2" translate (click)="$event.preventDefault(); setAllPermissions(schema.permissionGroups[1])" data-test-qa="setAll-UI">All</a><a class="ml-2" translate (click)="$event.preventDefault(); setNoPermissions(schema.permissionGroups[1])" data-test-qa="setNone-UI">None</a>
      </div>
      <div *ngFor="let p of schema.permissionGroups[1].items" [attr.data-test-qa]="p.id">
        <ng-container *ngIf="isPermissionVisible(p.id)">
          <checkbox (click)="clickPermission(p)" [checked]="permission[p.id] &amp;&amp; isPermissionAllowed(p.id)" [disabled]="!isPermissionAllowed(p.id)" [text]="p.name|translate" [attr.data-test-qa]="p.id"></checkbox>
        </ng-container>
      </div>
    </div>
  </div>
</div>